<p [ngClass]="classes">
    <ng-content></ng-content>
</p>